import { createClient } from '@supabase/supabase-js';
import { Database } from '../types/supabase.types';

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;
const SUPABASE_KEY = process.env.REACT_APP_SUPABASE_KEY;

export const supabase = createClient<Database>(SUPABASE_URL!, SUPABASE_KEY!, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
  },
});

(window as any).supabase = supabase;
